import { render, staticRenderFns } from "./selectTree.vue?vue&type=template&id=67870190"
import script from "./selectTree.vue?vue&type=script&lang=js"
export * from "./selectTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports